module.exports = __webpack_public_path__ + "img/6_dice[4].61e417bd.png";